// CSS 

//Lib 
import moment from 'moment';

// Api  
import api from '@/api/baseApi';

// Constant
import { SETTINGS_USER_API } from "@/constant/apiSettings";
import { API_CALL_STATUS } from "@/constant/baseConstant";
import { regex } from "@/constant/config";

// Extend
import base from '@/scripts/base';

// Component    

// Function  

export default {

  extends: base,

  components: {
  },

  data() {
    var validatePhone = (rule, value, callback) => {
      if (value.match(regex.phone)) {
        callback();
      } else {
        callback(new Error("Are you sure you are entering the phone number"));
      }
    };
    return {
      rules: {
        fullName: [
          {
            required: true,
            message: this.$lang.profile.validationRequiredFullName,
            trigger: "blur"
          },
          {
            max: 255,
            message: this.$lang.profile.validationMaxFullName,
            trigger: ["blur", "change"]
          }
        ],
        phone: [
          {
            required: true,
            message: this.$lang.profile.validationrequiredPhone,
            trigger: "blur"
          },
          { validator: validatePhone, trigger: ["blur", "change"] },
          {
            min: 7,
            message: this.$lang.profile.validationMinPhone,
            trigger: ["blur", "change"]
          },
          {
            max: 15,
            message: this.$lang.profile.validationMaxPhone,
            trigger: ["blur", "change"]
          }
        ],
        address: [
          {
            required: true,
            message: this.$lang.profile.validationRequiredAddress,
            trigger: "blur"
          },
          {
            max: 200,
            message: this.$lang.profile.validationMaxAddress,
            trigger: ["blur", "change"]
          }
        ],
        birthday: [
          {
            type: 'date',
            required: true, message: this.$lang.profile.validationRequiredBirthday,
            trigger: 'change'
          }
        ],
        gender: [
          {
            required: true,
            message: this.$lang.profile.validationRequiredGender,
            trigger: 'change'
          }
        ],
      },

      request: {},

      disabledSaveChanges: true,
    }
  },

  created() {
    this.getData();
  },

  methods: {

    //#region Invoice and Billing change information
    change() {
      this.disabledSaveChanges = false;
    },
    //#endregion

    // Limit size avatar
    beforeAvatarUpload(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length)
        return;

      if (files[0].type !== 'image/jpeg' && files[0].type !== 'image/png') {
        this.$message.error('Avatar picture must be JPG or PNG format!');
        return;
      }
      if (!((files[0].size / 1024 / 1024) < 2)) {
        this.$message.error('Avatar picture size can not exceed 2MB!');
        return;
      }

      var reader = new FileReader();
      reader.onload = (e) => {
        this.request.profilePhoto = e.target.result;
        this.disabledSaveChanges = false;
      };
      reader.readAsDataURL(files[0]);
    },

    //#region Profile ___ View
    getData() {
      this.feedStatusLoading(API_CALL_STATUS.LOADING);
      api.baseRequest(SETTINGS_USER_API.PROFILE_SETTINGS_VIEW, null)
        .then((res) => {
          let responsedData = res.data;
          this.request = responsedData;
          this.request.birthday = moment.utc(this.request.birthday).local().valueOf()
          this.feedStatusLoading(API_CALL_STATUS.SUCCESS, this.machineList);
        })
        .catch(error => {
          this.processCatchApiRequest(error, "Request failed ...")
        });
    },
    //#endregion 

    //#region Profile ___ Modify
    modify() {
      this.feedStatusLoading(API_CALL_STATUS.LOADING);
      setTimeout(() => {
        let data = {
          fullName: this.request.fullName,
          phone: this.request.phone,
          birthday: this.request.birthday,
          gender: this.request.gender,
          profilePhoto: this.request.profilePhoto,
          deviceInformation: JSON.stringify(this.getInformationClient())
        }
        api.baseRequest(SETTINGS_USER_API.PROFILE_SETTINGS_MODIFY, data)
          .then(() => {
            this.notificationSuccess('Success ... !', `Your information have been successfully saved`);
            this.disabledSaveChanges = true;
            this.feedStatusLoading(API_CALL_STATUS.SUCCESS);
          })
          .catch(error => {
            this.processCatchApiRequest(error, "Boot failed ...")
          });
      }, this.smoothTimeOut);
    },
    //#endregion
  },
}